import React from "react";
import "../css/CommonInputField.css";

const CommonInputField = ({
  id,
  label,
  type = "text",
  value,
  name,
  onChange,
  readOnly,
  required,
  error,
  maxLength,
  placeholder,
}) => (
  <div className="common-input-field-form-input-container">
    <label className="common-input-field-form-input-label">
      {label}
      {required && <span> *</span>}
    </label>
    <input
      id={id}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      className={readOnly ? "common-input-field-read-only" : "common-input-field-form-input"}
      placeholder={placeholder}
      required={required}
      maxLength={maxLength}
    />
    {error && <span className="common-input-field-input-error">{error}</span>}
  </div>
);

export default CommonInputField;
